// Light, dark or the system's (docs/brand.md: both themes on every page). The choice is a
// per-browser convenience, so it lives in localStorage and the page works without it.
export type Theme = 'system' | 'light' | 'dark'
const KEY = 'apsio.theme'

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement
  if (theme === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', theme)
}

export function saveTheme(theme: Theme): void {
  applyTheme(theme)
  try {
    if (theme === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, theme)
  } catch {
    // Storage blocked: the choice lasts for this page only.
  }
}
